// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__xYCF9","createdSearch":"index_createdSearch__kiiSS","custom_table":"index_custom_table__sn4rC"};